module.exports = "<div class=\"dashboard container\">\r\n    <div *ngFor=\"let dashboard of dashboards\" class=\"dashboardLink\" (click)=\"onSelect(dashboard)\">\r\n        <p class=\"dashboard-title\">{{dashboard.title}}</p>\r\n        <div class=\"dashboard-icon icon-action-arrow\"></div>    \r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/viewsmodule/dashboard/dashboard.home.html
// module id = 500
// module chunks = 0